import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Components
import SplashView from 'Console/components/SplashView';

import AppWrapper from 'Console/containers/AppWrapper';
// Utils
import configureStore from 'Console/configureStore';

const { store, persistor, history } = configureStore();

const Root = () => (
    <Provider store={store}>
        <PersistGate loading={<SplashView />} persistor={persistor}>
            <AppWrapper history={history} />
        </PersistGate>
    </Provider>
);

const rootNode = document.getElementById('yeself-console');

ReactDOM.render(<Root />, rootNode);
